const generateSessiondIdIfNotExists = async (sessionId, country, lang) => {
    if(!sessionId)  {
        try {
            const { sessionId: sessionIdGenerated } = await triggerRouterCreateSession(country, lang)
            return sessionIdGenerated
        } catch(e) {
            // Error handled silently for security
        }
    }
    return sessionId
}

export default generateSessiondIdIfNotExists